/* istanbul ignore file */

/* eslint-disable @typescript-eslint/typedef */

import { ContentBaseModel } from '../content-base.model';
import { ButtonItemModel, HeadlinesItemModel, ImageMediaItemModel } from '../items';
import { Lekkerland2026CmsBackgroundColors, ViewOptionsModel } from '../options';

export const TextMediaViewBackgroundColors = [
  'white',
  ...Lekkerland2026CmsBackgroundColors,
] as const;

export const TextMediaViewLayoutTypes = ['1-2', '2-1', '1-1'] as const;
export const TextMediaViewImagePositions = ['left', 'right'] as const;

export type TextMediaViewBackgroundColor = typeof TextMediaViewBackgroundColors[number];
export type TextMediaViewLayoutType = typeof TextMediaViewLayoutTypes[number];
export type TextMediaViewImagePosition = typeof TextMediaViewImagePositions[number];

export interface TextMediaViewOptionsModel extends ViewOptionsModel {
  background: TextMediaViewBackgroundColor;
  grid: TextMediaViewLayoutType;
  image: TextMediaViewImagePosition;
}

export interface TextMediaContentModel extends ContentBaseModel {
  type: 'text_media';
  view: TextMediaViewOptionsModel;
  headlines: HeadlinesItemModel;
  content: string | null;
  media_content: ImageMediaItemModel;
  button: ButtonItemModel;
}
